module.exports = __webpack_public_path__ + "static/media/pdf.ede71849.svg";